// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.test_session_file_kind_enum */
var TestSessionFileKindEnum;
(function (TestSessionFileKindEnum) {
    TestSessionFileKindEnum["REPORT"] = "REPORT";
    TestSessionFileKindEnum["RAW_EXPORT"] = "RAW_EXPORT";
    TestSessionFileKindEnum["ATTACHMENT"] = "ATTACHMENT";
})(TestSessionFileKindEnum || (TestSessionFileKindEnum = {}));
;
export default TestSessionFileKindEnum;
/** Zod schema for test_session_file_kind_enum */
export const testSessionFileKindEnum = z.nativeEnum(TestSessionFileKindEnum);
//# sourceMappingURL=TestSessionFileKindEnum.js.map